import type { HiredEquipmentAnchor, HiredEquipmentGridRowLocks } from '../types';

/**
 * Which per-row selectors the grid must lock vs. leave open, given the
 * submission's immutable entry method.
 *
 * - By PO: vendor + PO locked; task varies per line.
 * - By Subcontractor: vendor locked; each line picks PO + task (PO scoped to vendor).
 * - By Task: task locked; each line picks vendor + PO.
 */
export function getGridRowLocks(anchor: HiredEquipmentAnchor): HiredEquipmentGridRowLocks {
  switch (anchor.entryMethod) {
    case 'purchase_order':
      return {
        vendorLocked: true,
        poLocked: Boolean(anchor.lockedPoId),
        taskLocked: false,
        rowVendorSelectable: false,
        rowPoSelectable: !anchor.lockedPoId,
        rowTaskSelectable: true,
      };
    case 'subcontractor':
      return {
        vendorLocked: true,
        poLocked: false,
        taskLocked: false,
        rowVendorSelectable: false,
        rowPoSelectable: true,
        rowTaskSelectable: true,
      };
    case 'task':
      return {
        vendorLocked: false,
        poLocked: false,
        taskLocked: true,
        rowVendorSelectable: true,
        rowPoSelectable: true,
        rowTaskSelectable: false,
      };
  }
}
